import React from "react";
import { Input } from "antd";

import '../css/widget/widget.input.css';

const { TextArea } = Input;

const WidgetTextArea = ({placeholder = '请输入', suffix=<></>, onChange = () => {}, 
    onKeyUp = () => {}, style={ height: 120, resize: 'none'}, onClick = () =>{}, width, 
    defaultValue, value, showCount=false}) => {

    return (
        <div className="sf-textArea">
            <TextArea 
                placeholder={placeholder} 
                value={value}
                defaultValue={defaultValue}
                showCount={showCount}
                onChange={onChange}
                onKeyUp={onKeyUp}
                style={style}
                suffix={ suffix }
                onClick={onClick}
            />
        </div>
    )
}

export default WidgetTextArea;